module.exports = __webpack_public_path__ + "img/danfe.1aa6d880.png";